export const pluginPrefix = 'PLUGIN:ZAMZOW_LAWN:';
export const STORE_PRODUCTS_IN_CART = `${pluginPrefix}STORE_PRODUCTS_IN_CART`;
export const ONGOING_SALE = `${pluginPrefix}ONGOING_SALE`;
export const SELECTED_CUSTOMER = `${pluginPrefix}SELECTED_CUSTOMER`;
